export class MorayWestInstructionDTO {
    public units: string = "";
    public issuedFrom: Date | string | null = new Date().toISOString().split('T')[0];
    public issuedTo: Date | null = null;
    public dateComment: string = "";
    public fixed: number = 0;
    public strikePrice: number = 0;
    public negativePriceTrigger: number = 0;
    public amazon_commercial: number = 0;
    public amazon_commissioning: number = 0;
    public amazon_contracted: number = 0;
    public google_commercial_min: number = 0;
    public google_commercial_max: number = 0;
    public google_commissioning: number = 0;
    public google_contracted: number = 0;
    public engie_commissioning: number = 0;
    public engie_contracted: number = 0;
    public status: string ="";
    public isArchived: boolean = false;
    public isAppliedInPPA: boolean = false;
    public regoPrice: number = 0;
    public percentage: number = 0;
}